import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';


import AddStockOperationModel from "../stockfollowups/AddStockOperationModel";

import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';

import {  Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const StockFollowUpViewByConsumableLocation = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [datain, setDatain] = useState([]);
  const [dataout, setDataout] = useState([]);
  const [inventorieslist, setInventorieslist] = useState([]);
  const [finalproducts, setFinalproducts] = useState([]);
  
    const [showmodel, setshowmodel] = useState(false);
    const [stocksgroupby, setStocksgroupby] = useState({});

  const [permission, setPermission] = useState({});
  const [palletquantityout, setPalletquantityout] = useState(0);
      let season_id = localStorage.getItem("season_id");
  const ids_consumble = id.split("_");
  console.log(ids_consumble);

  useEffect(() => {
        setPermission(FindModuleById(151)); 
      console.log(permission);

      axios
      .get(`/stock-follow-ups/listing-groupby-comsumble-location-detail/${id+'_'+season_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setDatain(response.data.data.stocks_in);
        setDataout(response.data.data.stocks_out);
        setFinalproducts(response.data.data.final_products);

        let groupby = response.data.data.stocks_groupby[0];
          groupby.total_in_quantity = Number(groupby.total_in_quantity) + Number(response.data.data.inventories_totalQuantity);
          setStocksgroupby(groupby);

        

        setPalletquantityout(response.data.data.product_out_final);
        let inventories = response.data.data.inventories;
        setInventorieslist(inventories);
    
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const addForm = () => {
    console.log('add');
    setshowmodel(true);
  };

  const handleClose = () => {
    setshowmodel(false);
    //setshowmodelEdit(false);
    //setSelectedItemId(null);
  };
  
  // 🔹 Separate Cell Component for "Delivery Note"
const DeliveryNoteCell = ({ row }) => {
  if (row.original?.delivery_note) {
    return (
      <a
        className="btn btn-primary"
        href={viewFile(row.original.delivery_note)} // Ensure viewFile is defined
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        Download
      </a>
    );
  }
  return null; // Return nothing if delivery_note is null
};

// ✅ Define PropTypes
DeliveryNoteCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      delivery_note: PropTypes.string, // Ensure delivery_note is a string
    }),
  }).isRequired,
};

// 🔹 Column Configuration
const columns = [
  {
    accessorKey: 'location_name',
    header: 'Location',
  },
  {
    accessorKey: 'date',
    header: 'Date',
  },
  {
    accessorKey: 'operation',
    header: 'Operation',
  },
  {
    accessorKey: 'delivery_note_number',
    header: 'Delivery Note Number',
  },
  {
    header: 'Supplier',
    accessorFn: (row) =>
      row.supplier_detail ? row.supplier_detail.name : '',
  },
  {
    header: 'Consumable',
    accessorFn: (row) =>
      row.consumable_product ? row.consumable_product.consumable_name : '',
  },
  {
    accessorKey: 'quantity',
    header: 'Quantity',
  },
  {
    header: 'Unit Price',
    accessorFn: (row) =>
      `${row.unit_price}${row.currency_detail ? row.currency_detail.symbol : ''}`,
  },
  {
    header: 'Total Amount',
    accessorFn: (row) =>
      `${row.total_amount}${row.currency_detail ? row.currency_detail.symbol : ''}`,
  },
  {
    accessorKey: 'note',
    header: 'Note',
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
  },
  {
    header: 'Delivery Note',
    Cell: DeliveryNoteCell, // ✅ Use separate component
  },
 
 
];
   const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

 
  const editItem = (item)=>{
    window.location.href = "/stock-situations-edit/"+item;
  }
  

  // const deleteItemManual = (item) => {

  //   Swal.fire({
  //     title: 'Do you really want to delete this record?',
  //     //text: 'This action cannot be undone.',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'DELETE'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios.get(`/stock-follow-ups/delete-manual/${season_id+'-'+item}`, {
  //             headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //           })
  //           .then((response) => {
  //             console.log(response);
  //             if (response.data.code === 200) {
  //               Swal.fire(
  //                 'Deleted!',
  //                 'Your Record has been deleted.',
  //                 'success'
  //               );
  //               setTimeout(() => {
  //                 window.location.href = "/stock-situations-viewby-consumable-location/"+id;
  //               }, 500);
  //             }
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //           }); 
  //          }
  //   });
  // }

  const deleteItem = (item) => {
    let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/stock-follow-ups/delete2/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                 axios
                      .get(`/stock-follow-ups/listing-groupby-comsumble-location-detail/${id+'_'+season_id}`, {
                        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                      })
                      .then((response) => {
                        setDatain(response.data.data.stocks_in);
                        setDataout(response.data.data.stocks_out);
                        setFinalproducts(response.data.data.final_products);

                        let groupby = response.data.data.stocks_groupby[0];
                          groupby.total_in_quantity = Number(groupby.total_in_quantity) + Number(response.data.data.inventories_totalQuantity);
                          setStocksgroupby(groupby);

                        

                        setPalletquantityout(response.data.data.product_out_final);
                        let inventories = response.data.data.inventories;
                        setInventorieslist(inventories);
                    
                      })
                      .catch((error) => {
                        console.log(error);
                      });
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

  console.log(stocksgroupby);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(dataout);
// BarcodeNumberCell Component
const BarcodeNumberCell = ({ row }) => (
  <a href={`/production-output-view/${row.original.id}`}>
    {row.original.barcode_number}
  </a>
);

// CaliberCell Component
const CaliberCell = ({ row }) => {
  const calibreDisplay = row.original.items
    ? row.original.items.map((item) => item.calibre).join(' / ')
    : '';
  return <span>{calibreDisplay}</span>;
};
// NetWeightCell Component
const NetWeightCell = ({ row }) => {
  const totalSum = row.original.items
    ? row.original.items.reduce((sum, item) => sum + item.net_weight, 0)
    : 0;
  return <div>{totalSum}KG</div>;
};
// NumberOfBoxesCell Component
const NumberOfBoxesCell = ({ row }) => {
  const totalBoxes = row.original.items
    ? row.original.items.reduce((sum, item) => sum + item.number_of_boxes, 0)
    : 0;
  return <div>{totalBoxes}</div>;
};
// ✅ PropTypes validation
BarcodeNumberCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      barcode_number: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

CaliberCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          calibre: PropTypes.string,
        })
      ),
    }).isRequired,
  }).isRequired,
};
NetWeightCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          net_weight: PropTypes.number,
        })
      ),
    }).isRequired,
  }).isRequired,
};

NumberOfBoxesCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          number_of_boxes: PropTypes.number,
        })
      ),
    }).isRequired,
  }).isRequired,
};

const final_columns_2 = [
   {
      accessorKey: 'po_number',
      header: 'PO Number',
    },
    
    {
      header: 'type',
      accessorFn: (row) => row.ship_method ? row.ship_method.title : '',
    },
]

  const final_columns = [
    {
      header: 'Barcode Number',
      accessorFn: (row) => row.barcode_number,
      Cell: BarcodeNumberCell,
    },
    {
      header: 'Caliber',
      accessorFn: (row) => row.items ? row.items.map(item => item.calibre).join(' / ') : '',
      Cell: CaliberCell,
    },
 
    {
      header: 'Order Number',
      accessorFn: (row) => row.order_detail ? row.order_detail.po_number : '',
    },
   {
      header: 'Pallet Type',
      accessorFn: (row) => row.pallet_type_title ? row.pallet_type_title.title : '',
    },
    {
      header: 'Package Type',
      accessorFn: (row) => row.package_type ? row.package_type.title : '',
    },
       {
      header: 'Net Weight',
      accessorFn: (row) => row.items,
      Cell: NetWeightCell,
    },
    {
      header: 'Number Of Boxes',
      accessorFn: (row) => row.items,
      Cell: NumberOfBoxesCell,
    },
    {
      header: 'Quantity',
      accessorFn: (row) => {
        let ids =  id.split("_");
        let quanity =0;
       
        if(ids[0] == 1){
          quanity = 1*4;
        }
        else if(ids[0] == 2){
          quanity = 1;
        }
        else if(ids[0] == 3){
          quanity = 1;
        }
        else if(ids[0] == 5){
          quanity = row.items? row.items.reduce((sum, item) => sum + item.number_of_boxes, 0):0;
        }
        else if(ids[0] == 8){
          quanity = row.items? row.items.reduce((sum, item) => sum + item.number_of_boxes, 0):0;
        }
        else if(ids[0] == 10){
          quanity = row.items? row.items.reduce((sum, item) => sum + item.number_of_boxes, 0):0;
        }
        else if(ids[0] == 11){
          quanity = row.items? row.items.reduce((sum, item) => sum + item.number_of_boxes, 0):0;
        }
        else if(ids[0] == 4){
          let quanity12 = row.package_type.kg;
        let unit =0;
          if(quanity12 == 4){
            unit = (0.207);
          }
          if(quanity12 == 10 || quanity12 == 14 || quanity12 == 16){
            unit =  (0.161);
          }
          quanity = (unit/14.5).toFixed(4);
        }
        else if(ids[0] == 7){
          let quanity12 = row.package_type.kg;
          let unit =0;
          if(quanity12 == 4){
            unit = (9);
          }
          if(quanity12 == 10 || quanity12 == 14 || quanity12 == 16){
            unit =  (7);
          }
          quanity = (unit/2000).toFixed(4);
       
        }
        console.log(quanity);
        // Replace this with the actual logic to calculate or extract quantity
       return quanity ?? ''; // fallback to empty string if undefined
      },
    },

 
  ];
  
 
  const inventories_columns =[
   
    {
      header: 'Location',
      accessorFn: (row) => `${(row.location_name)?row.location_name:""} `,
    },  

    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },
   
    {
      header: 'Consumable',
      accessorFn: (row) => `${(row.consumable_product)?row.consumable_product.consumable_name:""} `,
    },  
    
    {
      accessorKey: 'quantity',
      header: 'Quantity',
    },
    {
      accessorKey: 'note',
      header: 'Note',
    },
  
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   ];
  
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Stock Situations Group By Consumable and Location </h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/profile">Profile</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/stock-situations">Stock Situations</Link>
                      </li>
                      <li className="breadcrumb-item active">Stock Situations Group By Consumable and Location</li>
                    </ul>
                </div>
                <div className="">
              <button  onClick={() => addForm()} className="btn btn-primary" style={{float:"right"}}>
                    <i className="fas fa-plus"></i>
                  </button>
          
              </div>
              </div>
            </div>
            <div className="row">
            <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity IN</div>
                          <div className="dash-counts">
                          <p>   {(parseFloat(stocksgroupby.total_in_quantity)).toFixed(2)}
                          </p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity OUT</div>
                          <div className="dash-counts">
                            <p>{(parseFloat(stocksgroupby.total_out_quantity || 0) + parseFloat(palletquantityout || 0)).toFixed(2)}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Quantity Available </div>
                          <div className="dash-counts">
                          <p>
                            {
                              (
                                (parseFloat(stocksgroupby.total_in_quantity || 0)) -
                                (parseFloat(stocksgroupby.total_out_quantity || 0) + parseFloat(palletquantityout || 0))
                              ).toFixed(2)
                              
                            }
                          </p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                      
                </div>

          
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                  <table className="table table-bordered">
                    <tr>
                   
                      <th  className="p-3">Consumble </th>
                      <td className="p-3">  {stocksgroupby.consumable_product ? stocksgroupby.consumable_product.consumable_name : ""}</td>
                    </tr>
                    <tr> <th className="p-3">Location </th>
                      <td className="p-3">
                        {stocksgroupby.location_name ? stocksgroupby.location_name : ""}
                      </td>
                    </tr>
                    
                
                  </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">

            <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-bottom">
                      

                      <li className="nav-item">
                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">IN</a>                                  
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " href="#listing-customer" data-bs-toggle="tab"> OUT</a>                                   
                      </li> 
                        <li className="nav-item">
                            <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Final Products</a>                                   
                        </li>    
                        <li className="nav-item">
                            <a className="nav-link " href="#listing-inventories" data-bs-toggle="tab"> Inverntories</a>                                   
                        </li>                    
                      </ul>
                      <div className="tab-content">

                      <div className="tab-pane show active" id="listing-groupby-supplier">
                      <div className="row"   id="listing-followup">
                        <div className="col-sm-12">
                          <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">

                                <MaterialReactTable columns={columns} data={datain} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            //renderColumnActionsMenuItems 
                                           
                                            renderRowActionMenuItems={({ row }) => [
                                                    permission?.update == 1 && (
                                                      <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                                        Edit
                                                      </MenuItem>
                                                    ),
                                                    permission?.delete == 1 && (
                                                      <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                        Delete
                                                      </MenuItem>
                                                    ),
                                                  ]}
                                            // renderRowActionMenuItems={({ row }) => {
                                            //   //console.log('Row:', row.original); // ← Add this
                                            
                                            //   const actions = [];
                                            //   const addType = row.original.add_type?.trim().toLowerCase();
                                            //   //console.log('Normalized add_type:', addType); // ← And this
                                            
                                            //   if (addType === 'manual') {
                                            //     actions.push(
                                            //       <MenuItem key="delete-manual" onClick={() => deleteItemManual(row.original.id)}>
                                            //         Delete
                                            //       </MenuItem>
                                            //     );
                                            //   } else {
                                            //     actions.push(
                                            //       <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                            //         Edit
                                            //       </MenuItem>,
                                            //       <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                            //         Delete
                                            //       </MenuItem>
                                            //     );
                                            //   }
                                            
                                            //   return actions;
                                            // }}
                                          />
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        
                        </div>                                
                        <div className="tab-pane  " id="listing-customer">
                              <div className="row"   id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <MaterialReactTable columns={columns} data={dataout} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                           
                                            renderRowActionMenuItems={({ row }) => [
                                                permission?.update == 1 && (
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                                    Edit
                                                  </MenuItem>
                                                ),
                                                permission?.delete == 1 && (
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ),
                                              ]}
                                              
                                            // renderRowActionMenuItems={({ row }) => {
                                            //   //console.log('Row:', row.original); // ← Add this
                                            
                                            //   const actions = [];
                                            //   const addType = row.original.add_type?.trim().toLowerCase();
                                            //   //console.log('Normalized add_type:', addType); // ← And this
                                            
                                            //   if (addType === 'manual') {
                                            //     actions.push(
                                            //       <MenuItem key="delete-manual" onClick={() => deleteItemManual(row.original.id)}>
                                            //         Delete
                                            //       </MenuItem>
                                            //     );
                                            //   } else {
                                            //     actions.push(
                                            //       <MenuItem key="edit" onClick={() => editItem(row.original.stock_follow_up_id)}>
                                            //         Edit
                                            //       </MenuItem>,
                                            //       <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                            //         Delete
                                            //       </MenuItem>
                                            //     );
                                            //   }
                                            
                                            //   return actions;
                                            // }}
                                          />
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div>                                
                                          
                        <div className="tab-pane  " id="listing-all">
                              <div className="row"   id="listing-followusp">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                         {ids_consumble[0] == '23' ? (
                                              <MaterialReactTable 
                                                columns={final_columns_2} 
                                                data={finalproducts} 
                                                enableColumnOrdering
                                                enablePinning
                                              />
                                            ) : (
                                              <MaterialReactTable 
                                                columns={final_columns} 
                                                data={finalproducts} 
                                                enableColumnOrdering
                                                enablePinning
                                              />
                                            )}
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div> 

                                        
                        <div className="tab-pane  " id="listing-inventories">
                              <div className="row"   id="listing-followusp1">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                              <MaterialReactTable 
                                                columns={inventories_columns} 
                                                data={inventorieslist} 
                                                enableColumnOrdering
                                                enablePinning
                                              />
                                            
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div>    
                      </div>                             
                    </div>

                      
                  </div>
                </div>
              </div>
            </div>


                    <AddStockOperationModel show={showmodel} handleClose={handleClose} />
          </div>
        </div>
      </div>
    </>
  );
};
export default StockFollowUpViewByConsumableLocation;
